__webpack_require__.p = "https://ads.wpcdn.pl/release-v1.455.0/public-desktop/";